'use strict';
var angular = require('angular');
var SignupService = /** @class */ (function () {
    function SignupService($http, Auth, googleAnalytic, SignupEvents) {
        'ngInject';
        this._$http = $http;
        this.Auth = Auth;
        this.GoogleAnalyticsService = googleAnalytic;
        this.signupEvents = SignupEvents;
        // Object to store our user properties
        this.current = null;
    }
    SignupService.prototype.fireEvent = function (eventName) {
        var event = this.signupEvents.practitionerSignUpTrackingEvents[eventName];
        if (!event)
            return;
        this.GoogleAnalyticsService.sendEvent(event.eventCategory, event.eventAction, event.eventLabel, 1);
    };
    SignupService.prototype.createAccount = function (user) {
        var _this = this;
        var newAccount = {};
        newAccount.businessName = user.businessName;
        newAccount.email = user.email;
        newAccount.billingAddress = {};
        newAccount.billingAddress.recipientName = user.firstName + ' ' + user.lastName;
        newAccount.billingAddress.line1 = (user.address1 !== null ? user.address1 : '');
        newAccount.billingAddress.line2 = (user.address2 !== null ? user.address2 : '');
        newAccount.billingAddress.city = (user.city !== null ? user.city : '');
        newAccount.billingAddress.regionCode = (user.state.regionCode !== null ? user.state.regionCode : '');
        newAccount.billingAddress.regionName = (user.state.regionName !== null ? user.state.regionName : '');
        newAccount.billingAddress.postalCode = (user.postalCode !== null ? user.postalCode : '');
        newAccount.billingAddress.countryCode = (user.country.countryCode !== null ? user.country.countryCode : '');
        newAccount.billingAddress.countryName = (user.country.countryName !== null ? user.country.countryName : '');
        newAccount.billingAddress.phoneNumber = (user.phone !== null ? user.phone : '');
        newAccount.billingAddress.phoneNumberExt = (user.ext !== null ? user.ext : '');
        newAccount.defaultShippingAddress = {};
        newAccount.defaultShippingAddress.recipientName = user.firstName + ' ' + user.lastName;
        newAccount.defaultShippingAddress.line1 = (user.address1 !== null ? user.address1 : '');
        newAccount.defaultShippingAddress.line2 = (user.address2 !== null ? user.address2 : '');
        newAccount.defaultShippingAddress.city = (user.city !== null ? user.city : '');
        newAccount.defaultShippingAddress.regionCode = (user.state.regionCode !== null ? user.state.regionCode : '');
        newAccount.defaultShippingAddress.regionName = (user.state.regionName !== null ? user.state.regionName : '');
        newAccount.defaultShippingAddress.postalCode = (user.postalCode !== null ? user.postalCode : '');
        newAccount.defaultShippingAddress.countryCode = (user.country.countryCode !== null ? user.country.countryCode : '');
        newAccount.defaultShippingAddress.countryName = (user.country.countryName !== null ? user.country.countryName : '');
        newAccount.defaultShippingAddress.phoneNumber = (user.phone !== null ? user.phone : '');
        newAccount.defaultShippingAddress.phoneNumberExt = (user.ext !== null ? user.ext : '');
        newAccount.defaultShippingAddress.isDefault = true;
        newAccount.password = (user.password !== null ? user.password : '');
        newAccount.phoneNumber = (user.phone !== null ? user.phone : '');
        newAccount.phoneNumberExt = (user.ext !== null ? user.ext : '');
        newAccount.faxNumber = (user.fax !== null ? user.fax : '');
        newAccount.accountType = user.accountType;
        newAccount.firstName = (user.firstName !== null ? user.firstName : '');
        newAccount.middleInitial = (user.middleInitial !== null ? user.middleInitial : '');
        newAccount.lastName = (user.lastName !== null ? user.lastName : '');
        newAccount.title = (user.title !== null ? user.title : '');
        newAccount.suffix = (user.suffix !== null ? user.suffix : '');
        newAccount.professionalDesignations = (user.designation !== null ? user.designation : '');
        newAccount.credentials = (user.credentials !== null ? user.credentials : '');
        this.Auth.clearLoginCache();
        this.Auth.clearAccountCache();
        var request = this._$http.post('api/account/', newAccount);
        return (request.then(function (response) {
            var user = response.data.response;
            if (response.data.errors) {
                user.errors = response.data.errors;
            }
            if (response.data.warnings) {
                user.warnings = response.data.warnings;
            }
            _this.Auth.setCurrentUser(user);
            return response;
        }, this.handleError));
    };
    SignupService.prototype.getAuthenticated = function (user) {
        return this._$http.post('api/account/postreg', user)
            .then(this.handleSuccess, this.handleError);
    };
    SignupService.prototype.getPatientSchema = function () {
        var request = this._$http({
            method: 'get',
            url: 'api/signups/practitioner/schema',
            params: {
                action: 'get'
            }
        });
        return (request.then(this.handleSuccess, this.handleError));
    };
    SignupService.prototype.getPractitionerSchema = function () {
        var request = this._$http({
            method: 'get',
            url: 'api/signups/patient/schema',
            params: {
                action: 'get'
            }
        });
        return (request.then(this.handleSuccess, this.handleError));
    };
    SignupService.prototype.handleSuccess = function (response) {
        return response;
    };
    SignupService.prototype.handleError = function (response) {
        return response;
    };
    SignupService.prototype.isMobileDevice = function () {
        return (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };
    ;
    return SignupService;
}());
export default SignupService;
//# sourceMappingURL=signup.service.js.map